<router-outlet></router-outlet>
@defer{

<sml-toastr [maxItems]="3" [isGlobal]="true" [queueAlerts]="true"></sml-toastr>
@if (showSpinner) {
<sml-spinner [showImage]="true"></sml-spinner>
}
<!-- @if (showFormSpinner) {
<sml-form-spinner [showFormImage]="showFormSpinner"></sml-form-spinner>
} -->

<head><link rel="preload" as="image" href="/assets/images/Confirmation-Background.png" /></head>

@if(showCancelSurveyDialog){
  <sml-dialog  [size]="'md'" [hasConfirmationDialog]="true" [isOpen]="showCancelSurveyDialog"  class="!tw-bg-opacity-80 story-dailog !tw-z-[9999]"
    [dialogTitle]="formDetailStrings.CLOSE_FORM" [dialogTitlePosition]="'center'"
    [dialogHeaderContent]="formDetailStrings.CLOSE_FORM_SUBHEADING" [dialogHeaderContentPosition]="'center'"
    (closed)="onClosePopup()" [src]="'/assets/images/landing/exclamation.png'" [iconPosition]="'center'">
    <ng-container footer *ngIf="showCancelSurveyDialog">
      <div
        class="tw-flex tw-justify-between tw-items-center tw-py-4 tw-px-8 tw-border-t tw-border-solid tw-border-mercury-200">
        <button smlButton="link" [size]="'sm'" [rounded]="'md'" (click)="onCloseFormDialog()" class="!tw-pl-0">
          {{ formDetailStrings.CLOSE_FORM_CANCEL_TEXT }}
        </button>
        <div class="">
          <button smlButton="primary" [size]="'sm'" [rounded]="'md'" (click)="onConfirmCloseFormDialog()">
            {{formDetailStrings.CLOSE_FORM_SAVE_TEXT }}
          </button>
        </div>
      </div>
    </ng-container>
  </sml-dialog>
  }

@if(showParticipate){
<sml-dialog [customDialogBodySpacing]="'!tw-p-0'" [isOpen]="showParticipate" size="xl" class="!tw-bg-opacity-80"
  modalClass="!tw-overflow-x-hidden !tw-w-full tablet:!tw-w-[95%] laptop:!tw-max-w-[964px] laptop:!tw-w-[964px]">
  @if (showParticipate) {
  <lib-survey [timeZoneData]="timeZoneData" [formTitle]="formTitle" [formDescription]="formDescription"
    [isProposeForm]="isProposeForm" [communityData]="communityData" [previewFormData]="previewFormData"
    [isFromParticipateNow]="true" (closeParticipateModal)="closeParticipateModal()" [itemData]="itemData() || null"
    [selectedShift]="selectedShift || null"
    [customItemPrice]="customItemPrice || null" [isVolunteer]="isVolunteer" [isCalledFromItemDrawer]="isCalledFromItemDrawer"></lib-survey>
  }
</sml-dialog>
}

@if(showParticipateConfirmation && !isMobileView){
<sml-dialog [customDialogBodySpacing]="'!tw-p-0'" [isOpen]="showParticipateConfirmation" size="xl"
  class="!tw-bg-opacity-80 story-dailog !tw-z-[9999]" modalClass="!tw-w-full tablet:!tw-w-[600px] ">
  @if(errormsg){
  {{errormsg}}
  }
  @else {
  <div
    class="tw-bg-white tw-rounded-xl tw-shadow-xl conf-back tablet:tw-p-8 tw-pt-[30px] tw-text-center tw-h-[235px] tablet:tw-h-[352px]">
    <div class="tw-flex tw-flex-col tw-justify-between tw-h-full tw-items-center">
      <div class="tw-flex tw-flex-col tw-h-full tw-items-center tw-gap-[4px]">
        <div class="white-bg">
          <img src="./assets/images/Payment-Confirmation-icon.svg" alt="Payment Confirmation"
            class="!tw-w-[100px] !tw-h-[100px]">
          <h1
            class="tw-text-black tw-text-center tw-font-sans tw-text-[24px] tablet:tw-text-[28px] tw-font-bold tw-not-italic tw-leading-none">
            {{showParticipateConfirmationHeader}}
          </h1>
          <p
            class="tw-text-black tw-text-center tw-font-sans tw-text-[14px] tablet:tw-text-[16px] tw-font-normal tw-not-italic tw-leading-[22px] tablet:tw-pt-[15px]">
            You will receive an email from SeeMyLegacy shortly.
          </p>
        </div>
      </div>
      <button [smlButton]="'secondary'" [size]="'sm'" [rounded]="'lg'" class="tw-cursor-pointer tw-h-[40px] tw-w-[85px]"
        (click)="onCloseContributionModal()">
        Close
      </button>
    </div>
  </div>
  }
</sml-dialog>
}


@if(showParticipateConfirmation && isMobileView){
<div
  class="!tw-z-[9999] tw-flex tw-flex-col tw-item-center tw-visible tw-block tw-opacity-100 tw-fixed tw-top-0 tw-left-0 tw-z-[999] tw-h-full tw-w-full tw-overflow-y-auto tw-overflow-x-hidden tw-bg-white">
  <div class="tw-flex conf-bg-top tw-h-[35%] tw-w-full"></div>
  <div class="tw-flex tw-flex-col tw-justify-between tablet:tw-h-full tw-items-center tw-h-[30%] tw-w-full">
    <div class="tw-flex tw-flex-col tw-h-full tw-items-center tw-gap-[4px]">
      <img src="./assets/images/Payment-Confirmation-icon.svg" alt="Payment Confirmation"
        class="!tw-w-[100px] !tw-h-[100px]">
      <h1
        class="tw-text-black tw-text-center tw-font-sans tw-text-[24px] tablet:tw-text-[28px] tw-font-bold tw-not-italic tw-leading-none">
        {{showParticipateConfirmationHeader}}
      </h1>
      <p
        class="tw-text-black tw-text-center tw-font-sans tw-text-[14px] tablet:tw-text-[16px] tw-font-normal tw-not-italic tw-leading-[22px] tablet:tw-pt-[15px]">
        You will receive an email from SeeMyLegacy shortly.
      </p>
    </div>
    <button [smlButton]="'secondary'" [size]="'sm'" [rounded]="'lg'" class="tw-cursor-pointer tw-h-[40px] tw-w-[85px]"
      (click)="onCloseContributionModal()">
      Close
    </button>
  </div>
  <div class="tw-flex conf-bg-bottom tw-h-[35%] tw-w-full"></div>
</div>
}

@if (previewStory && !showParticipate) {
<sml-dialog [customDialogBodySpacing]="'!tw-p-0'" [isOpen]="previewStory" size="xl"
  class="!tw-bg-opacity-80 story-dailog" modalClass="!tw-w-full tablet:!tw-w-[95%] laptop:!tw-w-[964px]" [ngClass]="{'!tw-bg-transparent !tw-backdrop-blur-[0px] !tw-blur-0':isSharedLoggedOutUser}">
  <sml-view-story [story]="storyData()?.story || null" [itemData]="storyData()?.item || null" [isInteractiveTourCampaign]="isInteractiveTourCampaign"
    [allowEdit]="storyData()?.allowEdit || false" [allowShare]="storyData()?.allowShare || false"
    [fromModal]="storyData()?.fromModal || false" [isPageClicked]="storyData()?.isPageClicked || false"
    [pageId]="storyData()?.pageIndex || 0" [selectedTab]="storyData()?.selectedTab || ''"
    [viewType]="storyData()?.viewType || 'plaque'" [campaignId]="storyData()?.campaignId || null"
    (closeModal)="closeModal()" [userAccessLevel]="storyData()?.userAccessLevel || false" (openItemDrawerEvent)="openItemDrawer($event)" (openGenerateDrawerOpen)="openQRcodeGenerateDrawer($event)" (openDuplicatePopUp)="openCloneModal($event)" />
</sml-dialog>
}
<sml-lightbox></sml-lightbox>
}
<sml-drawer [bodyClass]="'tw-bg-white !tw-pt-0'" [drawerConatinerMain]="'!tw-pt-0'" size="md" [@slideInOut] *ngIf="isItemDrawerOpen">
  <div class="tw-block" header>
    <div class="tw-flex tw-gap-2 tw-justify-between">
      <!-- <button type="button" class="md:tw-hidden" (click)="closeDrawer()">
        <i-icon [name]="'arrow-back'" [height]="'tw-h-6'" [width]="'tw-w-6'"></i-icon>
      </button> -->
      <h3 class="tw-text-primary-950 tw-text-base md:tw-text-lg xl:tw-text-xl tw-font-bold md:tw-mb-1">
        {{'Edit' + ' ' + getDrawerHeading(storyData()?.item?.campaignTypeId ?? 0)}} 
      </h3>
      <button type="button" class="" (click)="handleBackClick(true)">
        <i-icon [name]="'close'" [height]="'tw-h-6'" [width]="'tw-w-6'"></i-icon>
      </button>
    </div>
    <!-- <p class="tw-text-grey-750 tw-text-sm tw-leading-snug max-md:tw-hidden">
      {{ subHeading() }}
    </p> -->
  </div>
  <div class="" body>
    <sml-build-items [data]="convertedItemData" [listingTypeId]="storyData()?.item?.itemListingType"
      [originalDescription]="originalDescription"
      [typeCampaign]="storyData()?.item?.campaignTypeId ?? 0" [formOverviewModel]="formOverviewModel"
      [formListingDict]="formListingDict" [customForms]="customForms" [drawerSize]="true" [isStatusIdDonated]="storyData()?.item?.statusId === itemStatusType.Donated" [saveDirectly]="true" [isEditItem]="true" [campaignId]="storyData()?.item?.campaignId" [isFromCommunityStories]="isFromCommunityStories()" (closeDrawerEvent)="closeDrawer()" [disableShiftOptions]="storyData()?.item?.hasShifts ? true : false" [isDonated]="storyData()?.item?.statusId === itemStatusType.Donated" />
  </div>
   <div footer class="max-md:tw-px-4">
   @if (this.storyData()?.item?.statusId === this.itemStatusType.Available && isMobile  && !this.storyData()?.item?.customMaxPrice && !this.storyData()?.item?.isUnlimitedParticipation){
     <button type="button" id="user-dialog-cancel-button" class="tw-mb-2" [smlButton]="'primary'" [block]="true" [size]="'sm'" [rounded]="'md'" (click)="onSaveClick()">
       Save
      </button>
      }
  <div class="tw-flex tw-items-center tw-justify-between" >
    <div class="tw-flex tablet:tw-gap-[40px]" [ngClass]="{'max-md:tw-justify-between max-md:tw-w-full':this.storyData()?.item?.statusId === this.itemStatusType.Available}">
      <div class="tw-text-[#A91E14] tw-items-center tw-flex tw-gap-[8px]" (click)="deleteItem()">
        <i-icon [name]="'trash'" class="!tw-w-4 !tw-h-4"></i-icon>
        <div class="tw-text-sm tw-leading-[22px] tw-font-medium tw-cursor-pointer">
          {{getDeleteDynamicText(storyData()?.item?.campaignTypeId ?? 0)}}
        </div>
      </div>

      @if (this.storyData()?.item?.statusId === this.itemStatusType.Available && !this.storyData()?.item?.customMaxPrice && !this.storyData()?.item?.isUnlimitedParticipation){
      <div class="tw-text-[#A91E14] tw-flex tw-items-center tw-gap-2 tw-cursor-pointer" (click)="closeItem()">
        <i-icon [name]="'close-participation'" class="!tw-w-4 !tw-h-4"></i-icon>
        <div class="tw-text-[#106B8E] tw-text-center tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[22px]">
         Close Participation
        </div>
      </div>
      }
    </div>
 @if(!(this.storyData()?.item?.statusId === this.itemStatusType.Available && isMobile  && !this.storyData()?.item?.customMaxPrice && !this.storyData()?.item?.isUnlimitedParticipation)){
      <button type="button" id="user-dialog-cancel-button" [smlButton]="'primary'" [size]="'sm'" (click)="onSaveClick()">
       Save
      </button>
    }
  </div>
    </div>
</sml-drawer>

<sml-dialog #smlModal [size]="'md'" (closed)="onCloseParticipationDialogClosed()" [hasConfirmationDialog]="true" [dialogTitle]="
  isDeleteClick ? 'Delete' + ' ' + getDrawerHeading(storyData()?.item?.campaignTypeId ?? 0):
    isClick ? (!!this.storyData()?.item?.id ? popupStrings.SAVE_HEADING : popupStrings.ADD_HEADING) : isSetQuantityClick?'Close this Option?': popupStrings.CANCEL_HEADING
  " [dialogTitlePosition]="'center'" [dialogHeaderContent]="isSetQuantityClick?'This will prevent all future participation and you will not be able to re-open this item for public participation.':
  isDeleteClick ? (this.storyData()?.item?.campaignId
      ? !this.storyData()?.item?.plaqueId ? 'Are you sure you want to delete this ' + getDrawerHeading(storyData()?.item?.campaignTypeId ?? 0) + '? Deleting it will permanently remove it this <strong>campaign</strong>. This action cannot be undone.' : 'Are you sure you want to delete this ' + getDrawerHeading(storyData()?.item?.campaignTypeId ?? 0) + '? Deleting it will permanently remove it from both the <strong>campaign</strong> and this <strong>community</strong>. This action cannot be undone.'
      : 'Are you sure you want to delete this ' + getDrawerHeading(storyData()?.item?.campaignTypeId ?? 0) + '? Deleting it will permanently remove it from this <strong>community</strong>. This action cannot be undone.') :
    isClick
      ? (!!this.storyData()?.item?.id ? popupStrings.SAVE_TEXT_SUBHEADING : popupStrings.ADD_TEXT_SUBHEADING)
      : (!this.storyData()?.item?.id ? popupStrings.CANCEL_TEXT_SUBHEADING1 : popupStrings.CANCEL_TEXT_SUBHEADING2)
  " [dialogHeaderContentPosition]="'center'" [src]="isSetQuantityClick?'./assets/images/landing/close-participation.png':!isClick ? './assets/images/landing/exclamation.png':'./assets/images/landing/Save-tick.png'" [iconPosition]="'center'">
  <ng-container footer>
    <div class="tw-flex tw-justify-between tw-items-center tw-py-4 tw-px-8 tw-border-t tw-border-solid tw-border-mercury-200" [ngClass]="{'max-md:tw-flex-col-reverse max-md:tw-gap-6':isSetQuantityClick}">
      <button smlButton="link" [size]="'sm'" [rounded]="'md'" (click)="cancel()" class="!tw-pl-0">
        {{ isClick || isDeleteClick  ? updateItemString.CANCEL_TEXT : isSetQuantityClick?"No, Keep it Open": popupStrings.KEEP_EDITING_TEXT }}
      </button>

      <div class="">
        <button smlButton="primary" [size]="'sm'" [rounded]="'md'" (click)="isSetQuantityClick 
            ? setItemQuantityToZero() 
            : (isDeleteClick 
                ? onDelete() 
                : isSave())">
          {{
            
          isDeleteClick ? popupStrings.DELETE_TEXT :
          isClick ? (!!this.storyData()?.item?.id ? popupStrings.SAVE_TEXT :popupStrings.ADD_TEXT) :isSetQuantityClick?'Yes, Close Option' :updateItemString.CANCEL_TEXT
          }}
        </button>
      </div>
    </div>
  </ng-container>
</sml-dialog>
@if(isDrawerOpen){
<sml-drawer [drawerType]="isMobile ? 'bottom' : 'side'" [size]="'xs'" (close)="handleClose($event)"
  [drawerContainerClasses]="!isIframe?'':'laptop:!tw-right-[0%] desktop:!-tw-right-[47%] laptop:!tw-absolute  laptop:!tw-top-[-16px] laptop:!tw-h-[103%] desktop:!tw-absolute  desktop:!tw-top-[-16px] desktop:!tw-h-[103%]'" class="!tw-z-[999]">
  <div class="tw-block" header>
    <div class="tw-flex tw-gap-2 md:tw-justify-between max-md:tw-justify-center">
      <button *ngIf="!isMobile" type="button" class="md:tw-hidden" (click)="isDrawerOpen = false">
        <i-icon [name]="'arrow-back'" [height]="'tw-h-[18px]'" [width]="'tw-w-[18px]'" class="!tw-block"></i-icon>
      </button>
      <h3 class="tw-text-grey-950 tw-text-xl tw-font-bold md:tw-mb-1 max-md:tw-text-center">Get Your Item QR
        Code
      </h3>
      <button type="button" class="max-md:tw-hidden" id="user-dialog-close-button" (click)="isDrawerOpen = false">
        <i-icon name="close" [height]="'tw-h-6'" [width]="'tw-w-6'"></i-icon>
      </button>
    </div>
    <div>
      <ng-container *ngTemplateOutlet="SubheaderText"></ng-container>
    </div>
  </div>
  <div class="" body>
    <div class="tw-border-dashed tw-border tw-rounded-xl tw-bg-surface-100 tw-py-8">
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-8">
        <img [src]="qrCodeImageUrl" alt="QR not available" class="tw-rounded-xl !tw-w-[200px] !tw-h-[200px]">
        <ng-container *ngIf="!isMobile">
          <div class="tw-flex tw-justify-around tw-w-full tw-px-[27px] tw-gap-8">
            <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="tw-px-8 tw-pt-[18px]  tw-pb-8 tw-flex tw-w-full tw-justify-around tw-gap-[30px]" *ngIf="isMobile">
      <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
    </div>
  </div>
  <div footer class="tw-text-end">
    <button smlButton="link" [size]="'sm'" (click)="isDrawerOpen=false">
      Close
    </button>
  </div>
</sml-drawer>

<ng-template #actionButtons>
  <button smlButton="secondary" [size]="'sm'" [rounded]="'md'" class="!tw-hidden tablet:!tw-inline-flex w-w-1/2"
    (click)="copyImage()">
    <div class="tw-flex tw-gap-2 tw-items-center">
      <i-icon [name]="'copy'" class="!tw-w-4 !tw-h-4 !tw-block"></i-icon>
      <div>
        Copy PNG
      </div>
    </div>
  </button>
  <button smlButton="primary" [size]="'sm'" [rounded]="'md'" class="tw-w-1/2" (click)="downloadImage()">
    <div class="tw-flex tw-gap-2 tw-items-center">
      <i-icon [name]="'download'" class="!tw-w-4 !tw-h-4 !tw-block"></i-icon>
      <div>
        Download
      </div>
    </div>
  </button>
</ng-template>
<ng-template #SubheaderText>
  <p class="tw-text-grey-750 tw-text-sm tw-leading-snug max-md:tw-text-center">Click 👉🏼 "Download" to quickly
    generate
    and save the QR code for your item!</p>
</ng-template>
}
@if(cloneItem){
  <sml-dialog #smlCloneModal [size]="'md'" [isOpen]="cloneItem" [hasConfirmationDialog]="true" [dialogTitle]="storyData()?.item?.statusId === itemStatusEnum.Available ? 'Duplicate this Option?' : 'Duplicate this Record?'" [dialogTitlePosition]="'center'" [dialogHeaderContent]="
  storyData()?.item?.statusId === itemStatusEnum.Available
    ? 'This option will be copied within the current campaign. You’ll be able to edit the details once it’s duplicated.'
    : 'This record will be copied within the current campaign. You’ll be able to edit the details once it’s duplicated.'
" [dialogHeaderContentPosition]="'center'" [src]="'./assets/images/landing/Duplicate.png'" [iconPosition]="'center'">
  <ng-container footer>
    <div
      class="tw-flex tw-justify-between tw-items-center tw-py-4 tw-px-8 tw-border-t tw-border-solid tw-border-mercury-200">
      <button smlButton="link" [size]="'sm'" [rounded]="'md'" (click)="cancelDuplicateModal()" class="!tw-pl-0">
        Cancel
      </button>

      <div class="">
        <button type="button" smlButton="primary" [size]="'sm'" [rounded]="'md'" (click)="cloneCampaignItem()">
         {{storyData()?.item?.statusId === itemStatusEnum.Available ? 'Yes, Duplicate Option' : 'Yes, Duplicate Record'}}
        </button>
      </div>
    </div>
  </ng-container>
</sml-dialog>
}